import { useLang } from 'hooks/lang';
import { ReactNode } from 'react';

import { Column, Row, Skeleton, Label } from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';

import { loaders } from 'entities';
import { DEFAULT_ANOTHER_SOURCE_SALES_USER } from 'utils/constants';

interface UserInputProps {
  children?: never;
  id?: string;
  label: ReactNode;

  side?: 'left' | 'right';
}

export function UserRef({ id, label, side = 'left' }: UserInputProps): JSX.Element {
  const { t } = useLang();

  const isAnotherSource = id === DEFAULT_ANOTHER_SOURCE_SALES_USER.id;

  const { data: user, loading: userLoading } = loaders.users.find.use({
    blockLoad: !id || isAnotherSource,
    params: { id: id! },
  });

  if (userLoading)
    return (
      <Row gap="2" justifyContent={side === 'left' ? undefined : 'flex-end'}>
        {side === 'left' ? (
          <>
            <Skeleton circle height={32} width={32} />

            <Skeleton width={120} />
          </>
        ) : (
          <>
            <Skeleton width={120} />

            <Skeleton circle height={32} width={32} />
          </>
        )}
      </Row>
    );

  if (side === 'left')
    return (
      <Row gap="2">
        <UserAvatar user={user ?? DEFAULT_ANOTHER_SOURCE_SALES_USER} size={32} />

        <Column gap="1">
          <Label>{label}</Label>
          <span>{isAnotherSource ? t(DEFAULT_ANOTHER_SOURCE_SALES_USER.id) : user?.name}</span>
        </Column>
      </Row>
    );

  return (
    <Row gap="2" justifyContent="flex-end">
      <Column gap="0" alignItems="flex-end">
        <Label>{label}</Label>
        <span>{isAnotherSource ? t(DEFAULT_ANOTHER_SOURCE_SALES_USER.id) : user?.name}</span>
      </Column>

      <UserAvatar user={user ?? DEFAULT_ANOTHER_SOURCE_SALES_USER} size={32} />
    </Row>
  );
}
